import { render, staticRenderFns } from "./previewPage.vue?vue&type=template&id=6b04acc1&scoped=true"
import script from "./previewPage.vue?vue&type=script&lang=js"
export * from "./previewPage.vue?vue&type=script&lang=js"
import style0 from "./previewPage.vue?vue&type=style&index=0&id=6b04acc1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b04acc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b04acc1')) {
      api.createRecord('6b04acc1', component.options)
    } else {
      api.reload('6b04acc1', component.options)
    }
    module.hot.accept("./previewPage.vue?vue&type=template&id=6b04acc1&scoped=true", function () {
      api.rerender('6b04acc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/settings/previewPage.vue"
export default component.exports